import React from "react";

import { useSessionStorage } from "./services/useSessionStorage";

const UserContext = React.createContext();

const useUserProfileContext = (client) => {
  const [context, setContext] = useSessionStorage("userProfile", null);
  if (!context) {
    console.time("Querying for User Profile");
    client
      .query(getUserProfileQuery)
      .toPromise()
      .then((response) => {
        if (response.error) throw new Error(response.error);
        const userProfile = response.data?.userProfile;

        if (userProfile && userProfile.accountActive === false) {
          console.warn("Account is inactive. Redirecting to logout.");
          const message = encodeURIComponent("No active CDE account found");
          window.location.replace(`/logout.html?message=${message}`);
          return;
        }

        setContext(userProfile);
        console.timeEnd("Querying for User Profile");
      })
      .catch((e) => {
        if (/Token has expired\./.test(e.toString()))
          window.location.replace("/logout.html");
      });
  }
  return [context, setContext];
};

const getUserProfileQuery = `
  query GetUserProfile {
    userProfile {
      id
      accountActive
      email
      firstName
      lastName
      programAccess {
        permissions
        program
        reviewTypes
      }
      superAdmin
      _actions
    }
  }`;

export { UserContext, useUserProfileContext };
